import Vue from "vue";
import VueI18n from "vue-i18n";
import i18nTRJandarma from "../i18n/trjandarma.json";
import i18nTr from "../i18n/tr.json";
import i18nEn from "../i18n/en.json";
import i18nDe from "../i18n/de.json";
import i18nAz from "../i18n/az.json";
import i18nAr from "../i18n/ar.json";
import i18nRu from "../i18n/ru.json";
import i18nRo from "../i18n/ro.json";

let messages = {
  tr: process.env.VUE_APP_ENVIRONMENT == "Jandarma" ? i18nTRJandarma : i18nTr, // constanttan okunamadığı için string olarak kullanıldı.
  ro: i18nRo,
  en: i18nEn,
  de: i18nDe,
  az: i18nAz,
  ar: i18nAr,
  ru: i18nRu
};
Vue.use(VueI18n);

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: getUserInitialLocale(), // set locale
  messages // set locale messages
});

function getUserInitialLocale() {
  const storedLocale = localStorage.getItem("preferredLanguage");
  if (storedLocale) {
    return storedLocale;
  }
  return getBrowserLanguage();
}

function getBrowserLanguage() {
  const browserLanguage = navigator.language.substring(0, 2).toLowerCase();
  if (browserLanguage && (browserLanguage == "en" || browserLanguage == "tr" || browserLanguage == "ro")) {
    localStorage.setItem("preferredLanguage", browserLanguage);
    return browserLanguage;
  }
  localStorage.setItem("preferredLanguage", "en");
  return "en";
}

export const setLocale = (locale) => {
  if (i18n.locale !== locale) {
    i18n.locale = locale;
    localStorage.setItem("preferredLanguage", locale);
  }
}

export default i18n;
